import { faTimesCircle, faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import FontAwesomeIcon from "app/components/layouts/Icons/FontAwesome";
import { TOEIC_P1, TOEIC_P2 } from 'app/constants/tests';
import { IELTS_TEST } from 'app/constants/categories';
import { AppStoreState } from 'app/redux/store';
import { useSelector } from 'react-redux';

const QuestionRadio = ({
  label,
  value,
  question,
  handleChange,
  textRadio,
  partId
}) => {
  const { process, test } = useSelector((state: AppStoreState) => state.test);
  const isCompleted = process === 'complete';
  const isEditable = process === 'ready';

  // Identifiers
  const questionName = `question_id_${question.id}`;
  const questionId = `${questionName}.${value}`;

  // States
  const isAnswer = question.answer == value;
  const isResultCorrect = question.result == value;

  // Test type conditions
  const isToeicP1orP2 = partId == TOEIC_P1 || partId == TOEIC_P2;
  const isIeltsTest = IELTS_TEST.includes(Number(test?.category_id));

  // Styling
  const labelClass = isResultCorrect ? 'text-success d-flex' : 'text-danger d-flex';
  const radioControlClass = isEditable ?
    'radio-control_focus radio-control__indicator' :
    'radio-control__indicator';

  const handleRadioChange = ({ target: { value } }) => handleChange(value, question);

  return (
    <div className="question-radio">
      <label className="radio-control mr-2">
        <input
          className="mr-2"
          type="radio"
          value={value}
          checked={isAnswer}
          disabled={!isEditable}
          name={questionName}
          onChange={handleRadioChange}
          id={questionId}
        />
        <div className={radioControlClass}>
          {textRadio}
        </div>
      </label>

      <label
        htmlFor={questionId}
        className={isCompleted && (isResultCorrect || isAnswer) ? labelClass : ''}
      >
        <div
          className={(isIeltsTest || isCompleted || !isToeicP1orP2) ? `d-inline pr-1` : 'd-none'}
          dangerouslySetInnerHTML={{ __html: label?.replace(/(<br\s*\/?>)+$/gi, "") }}
        />

        {isCompleted && isAnswer && (
          <FontAwesomeIcon
            className={`text-${isResultCorrect ? 'success' : 'danger'} mt-1`}
            icon={isResultCorrect ? faCheckCircle : faTimesCircle}
          />
        )}
      </label>
    </div>
  );
};

export default QuestionRadio;
